<template>
  <div>
    <v-row>
      <ValidationProvider ref="email" name="email" vid="email" slim mode="eager" :rules="rules" v-slot="{ errors }">
        <v-text-field
          v-model="email"
          :error-messages="errors[0]"
          :label="label"></v-text-field>
      </ValidationProvider>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'Email',
    props: ['field'],
    data: () => ({
      email: ''
    }),
    computed: {
      rules() {
        const {required, regexValidation} = this.field
        return {
          required,
          email: required && !regexValidation,
          ...((required && regexValidation) && {customRegex: regexValidation})
        }
      },
      requiredHint() {
        return this.field.required ? ' *' : '';
      },
      label() {
        return `${this.$t('registerScreen.placeholderEmail')} ${this.requiredHint}`
      }
    },
    watch: {
      email() {
        this.$emit('setAttribute', {
          key: 'email',
          value: this.email,
          identity: false
        });
      }
    }
  }
</script>

<style>

</style>
